var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"id":"menuButton","fab":"","flat":"","large":_vm.$vuetify.breakpoint.mdAndUp,"color":"red","icon":"","to":"/"}},[_c('v-icon',[_vm._v("exit_to_app")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }